// features/bonusPointSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../auth/api';
import {alertSuccess, alertError} from '../components/Alert'

// Async thunk to fetch bonus points
export const fetchBonusPoints = createAsyncThunk(
  'bonusPoint/fetchBonusPoints',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/account/panel/bonusPoint');
      return response.data; // Adjust based on API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Async thunk to update bonus points
export const updateBonusPoints = createAsyncThunk(
  'bonusPoint/updateBonusPoints',
  async (bonusPointData, { rejectWithValue }) => {
    try {
      const response = await api.patch('/account/panel/bonusPoint', bonusPointData);
      alertSuccess(response.data.success)
      return response // Adjust based on API response structure
    } catch (error) {
      alertSuccess(error.response?.data || error.message)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchReferralList = createAsyncThunk(
    'bonusPoint/fetchReferralList',
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get('/account/panel/ReferalList');
        return response.data; // Adjust based on API response structure
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );



  const bonusPointSlice = createSlice({
    name: 'bonusPoint',
    initialState: {
      points: [], // Stores the fetched bonus points
      referralList: [], // Stores the fetched referral list
      status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
      error: null, // Stores error messages
    },
    reducers: {
      // Optional reducers for synchronously managing bonus points
      clearBonusPoints(state) {
        state.points = [];
      },
      clearReferralList(state) {
        state.referralList = [];
      },
    },
    extraReducers: (builder) => {
      builder
        // Fetch Bonus Points
        .addCase(fetchBonusPoints.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchBonusPoints.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.points = action.payload;
        })
        .addCase(fetchBonusPoints.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        })
        // Update Bonus Points
        .addCase(updateBonusPoints.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(updateBonusPoints.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.points = Array.isArray(action.payload) ? action.payload : [];
        })
        .addCase(updateBonusPoints.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        })
        
        // Fetch Referral List
        .addCase(fetchReferralList.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(fetchReferralList.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.referralList = action.payload;
        })
        .addCase(fetchReferralList.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.payload;
        });
    },
  });
  
  export const { clearBonusPoints, clearReferralList } = bonusPointSlice.actions;
  
  export default bonusPointSlice.reducer;